import { ArrayElement } from 'dibs-ts-utils/exports/ArrayElement';

type Connection = {
    edges: readonly ({ node: ObjectType | null } | null)[] | null;
} | null;

export const flattenConnectionNodes = <T extends Connection>(
    connection: T
): NonNullable<ArrayElement<NonNullable<T>['edges']>>['node'][] => {
    const edges = connection?.edges || [];
    return edges.reduce<NonNullable<ArrayElement<NonNullable<T>['edges']>>['node'][]>(
        (acc, edge) => (edge ? acc.concat(edge.node) : acc),
        []
    );
};
